(() => {
  const language = document.documentElement.lang.toLowerCase().split('-')[0];
  if (!['es', 'fr', 'de', 'nl', 'pt', 'it', 'nb', 'no'].includes(language)) return;
  const selector = '[data-currentprice], .bndlr-container, .bndlr-volume-discounts';
  const normalize = (root) => {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if (node.parentElement.closest('script, style, input, textarea')) continue;
      const next = node.data.replace(/€\s*(\d[\d.,]*(?:[ \u00a0\u202f]\d{3})*(?:[.,]\d+)?)/g,
        (_, amount) => language === 'nl' ? `€\u00a0${amount}` : `${amount}\u00a0€`);
      if (next !== node.data) node.data = next;
    }
  };
  const init = () => {
    document.querySelectorAll(selector).forEach(normalize);
    new MutationObserver((records) => {
      const roots = new Set();
      for (const record of records) {
        const element = record.target.nodeType === Node.ELEMENT_NODE ? record.target : record.target.parentElement;
        const parent = element?.closest(selector);
        if (parent) roots.add(parent);
        for (const added of record.addedNodes) {
          if (added.nodeType !== Node.ELEMENT_NODE) continue;
          if (added.matches(selector)) roots.add(added);
          added.querySelectorAll(selector).forEach((root) => roots.add(root));
        }
      }
      roots.forEach(normalize);
    }).observe(document.body, { childList: true, characterData: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
